<app-page-header
  title="Home"
  titleLink="/reports"
  active_item="Log de Usuários"
>
</app-page-header>

<form [formGroup]="filters">
  <div class="row">
    <h5>Log de Usuários</h5>

    <div class="col-md-12 col-xl-12">
      <div
        class="card sales-summary shadow"
        [ngClass]="{
          'rounded-10': !isFilterCollapsed,
          'rounded-10-top': isFilterCollapsed,
        }"
      >
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.filters" | translate }}</div>
          <div class="card-options">
            <a
              href="javascript:void(0)"
              class="card-options-collapse"
              data-bs-toggle="card-collapse"
              (click)="toggleFilters()"
              [attr.aria-expanded]="!isFilterCollapsed"
            >
              <i
                class="fe fe-chevron-{{ !isFilterCollapsed ? 'up' : 'down' }}"
              ></i>
            </a>
          </div>
        </div>

        <div
          class="card-body filter-extrato"
          [(ngbCollapse)]="isFilterCollapsed"
        >
          <div class="row">
            <div class="col-xl-4 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtType" class="form-label">Tipo</label>
                <div class="input-icon-container">
                  <input
                    class="form-control pe-5"
                    type="text"
                    id="txtType"
                    [formControl]="filters.controls.type"
                    placeholder="Ex: LOGIN ACESSO"
                  />
                  <i
                    class="fe fe-clipboard input-icon cursor-pointer btn-color"
                    placement="top"
                    ngbTooltip="Colar"
                    (click)="pasteType()"
                  ></i>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">Usuário</label>

                <ng-select
                  [items]="usersSelect"
                  bindLabel="label"
                  bindValue="value"
                  [clearable]="false"
                  [searchable]="true"
                  [formControl]="filters.controls.userId"
                >
                </ng-select>
              </div>
            </div>

            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">Data inicial</label>

                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    #startText
                    matInput
                    [matDatepicker]="pickerIni"
                    placeholder="DD/MM/YYYY"
                    [formControl]="filters.controls.initialDate"
                    (input)="startRaw = startText.value"
                    (dateChange)="onDateChange('initialDate', startText.value)"
                    (blur)="parseDateInput('initialDate', startRaw)"
                    (keydown.enter)="parseDateInput('initialDate', startRaw)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerIni"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerIni startView="month"></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="col-xl-2 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">Data final</label>

                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    #endText
                    matInput
                    [matDatepicker]="pickerFim"
                    placeholder="DD/MM/YYYY"
                    [formControl]="filters.controls.endDate"
                    (input)="endRaw = endText.value"
                    (dateChange)="onDateChange('endDate', endText.value)"
                    (blur)="parseDateInput('endDate', endRaw)"
                    (keydown.enter)="parseDateInput('endDate', endRaw)"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerFim"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerFim startView="month"></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="col-xl-1 col-lg-6 col-sm-6">
              <button
                type="button"
                class="our-button btn btn-pill btn-primary"
                (click)="buscar(startRaw, endRaw)"
              >
                <i class="fe fe-search me-2"></i
                >{{ "common.searchButton" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-extrato" *ngIf="!isLoaded">
      <div class="dimmer active">
        <div class="lds-ring">
          <div></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card sales-summary rounded-10 shadow">
        <div class="card-header">
          <div class="card-title mb-0">{{ "common.history" | translate }}</div>
          <div class="card-options">
            <button type="button" class="btn btn-pill btn-default-light">
              <i class="fe fe-download me-2"></i>Exportar Excel
            </button>
          </div>
        </div>

        <div class="card-body button-table">
          <app-table-activity-log
            (logsLoaded)="onLogsLoaded()"
          ></app-table-activity-log>
        </div>
      </div>
    </div>
  </div>
</form>
